import { useContext } from 'react';
import {
  AnalyticsTrackerContext,
  AnalyticsTrackerContextType
} from '../containers/AnalyticsTrackerProvider';

export const useAnalyticsTracker = (): AnalyticsTrackerContextType => {
  return useContext(AnalyticsTrackerContext);
};
